// Styles
import './marquee-tile-editorial-modal.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initMarqueeTileModal = (context) => {

  const image = context.querySelector(".product__image");
  const title = context.querySelector(".product__title");
  const cPrice = context.querySelector(".product__cPrice");
  const sale = context.querySelector(".product__sale");
  const price = context.querySelector(".product__price");
  const url = context.querySelector(".product__url");
  const modal = context.querySelector(".marquee-tile-editorial-container-modal");

  document.querySelectorAll(".product__data").forEach((element) => {
    element.addEventListener('click', () => {
      image.src = element.dataset.image;
      title.textContent = element.dataset.title;
      cPrice.textContent = element.dataset.cprice;
      sale.textContent = element.dataset.sale;
      price.textContent = element.dataset.price;
      url.href = element.dataset.url

      cPrice.style.display = (element.dataset.cprice && element.dataset.cprice.trim() !== "") ? "block" : "none";
      sale.style.display = (element.dataset.sale && element.dataset.sale.trim() !== "") ? "block" : "none";

      modal.classList.add("show");

    });
  });

  window.addEventListener('scroll', () => {
    if (modal.classList.contains("show")) {
      modal.classList.remove("show");
    }
  });
}

if(document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.marquee-tile-editorial-modal'), (el) => {
    window.dAgency.initMarqueeTileModal(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.marquee-tile-editorial-container-modal'), (el) => {
      window.dAgency.initMarqueeTileModal(el);
    });
  });
}
